const LINKEDIN_LOADER_SCRIPT_ID = 'linkedin-insight-min-js'

export function hasLinkedInAdvertisingConsent(event) {
  const consent = event?.detail || window.CookieFirst?.consent
  return Boolean(consent?.advertising)
}

function bootstrapLinkedInLintrk() {
  if (!window.lintrk) {
    window.lintrk = function (a, b) {
      window.lintrk.q.push([a, b])
    }
    window.lintrk.q = []
  }
}

export function loadLinkedInInsight(partnerId) {
  if (!partnerId || document.getElementById(LINKEDIN_LOADER_SCRIPT_ID)) {
    return
  }

  bootstrapLinkedInLintrk()

  /* LinkedIn Insight Tag globals (required names from LinkedIn). */
  window._linkedin_partner_id = partnerId // eslint-disable-line camelcase
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [] // eslint-disable-line camelcase
  window._linkedin_data_partner_ids.push(window._linkedin_partner_id) // eslint-disable-line camelcase

  const script = document.createElement('script')
  script.id = LINKEDIN_LOADER_SCRIPT_ID
  script.type = 'text/javascript'
  script.async = true
  script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js'
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
}

export function maybeLoadLinkedInInsight(event) {
  if (process.env.NODE_ENV !== 'production') {
    return
  }

  const partnerId = window.__LINKEDIN_PARTNER_ID__
  if (!partnerId || !hasLinkedInAdvertisingConsent(event)) {
    return
  }

  loadLinkedInInsight(partnerId)
}
